export { default as AvgChart } from './AvgChart';
export { default as AvgRate } from './AvgRate';
export { default as AvgTasks } from './AvgTasks';
export { default as PageStatsTable } from './PageStatsTable';
export { default as WeeklyProgress } from './WeeklyProgress';

